import React, { useState, useCallback } from 'react';

export const useObservedItem = (observedItemIndex: number, setItems: React.Dispatch<any>) => {
    const [isObservedItemSeen, setIsObservedItemSeen] = useState(false);

    const setItemsWithRefs = useCallback(
        (items) => {
            setItems(() =>
                items?.map((item, index) => {
                    if (!item.ref) {
                        const ref = (node) => {
                            if (node && index === observedItemIndex && !isObservedItemSeen) {
                                const observer = new IntersectionObserver(
                                    (entries) => {
                                        entries.forEach((entry) => {
                                            if (entry.isIntersecting) {
                                                setIsObservedItemSeen(true);
                                                observer.disconnect();
                                            }
                                        });
                                    },
                                    { threshold: 1 }
                                );
                                observer.observe(node);
                            }
                        };
                        return { ...item, ref };
                    }
                    return item;
                })
            );
        },
        [setItems, observedItemIndex, isObservedItemSeen]
    );

    return { setItemsWithRefs, isObservedItemSeen };
};
